import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Sparkles, Lock, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * Floating ghost-tile prompts. AI-generated on premium accounts; locked teaser otherwise.
 * Used on Library + Workspace.
 */
export const GhostTiles = ({ onPick }) => {
  const { user } = useAuth();
  const [data, setData] = useState({ prompts: [], locked: true });
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    let mounted = true;
    api.get("/ghost-prompts").then((res) => mounted && setData(res.data)).catch(() => {}).finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, [user?.is_premium, user?.role]);

  if (loading || !data.prompts?.length) return null;
  const isOwner = user?.role === "owner";
  const isPremium = isOwner || user?.is_premium;

  return (
    <div className="relative mb-10" data-testid="ghost-tiles">
      <div className="flex items-center justify-between mb-3">
        <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#E60000] flex items-center gap-2">
          <Sparkles className="w-3 h-3" /> Ghost prompts {data.locked && <Lock className="w-3 h-3" />}
        </div>
        {!isPremium && (
          <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-black/40">
            Premium · examples only
          </span>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {data.prompts.slice(0, 5).map((p, i) => (
          <button
            key={i}
            onClick={() => {
              if (!isPremium) return nav("/workspace#upgrade");
              onPick?.(p);
            }}
            data-testid={`ghost-tile-${i}`}
            className={`group relative text-left p-4 border transition-all hover:-translate-y-0.5 ${
              isPremium
                ? "border-black/15 bg-white hover:border-black hover:shadow-[4px_4px_0_0_#E60000]"
                : "border-dashed border-black/15 bg-black/[0.02]"
            }`}
            style={{ animationDelay: `${i * 60}ms` }}
          >
            <Sparkles className={`w-3.5 h-3.5 mb-3 ${isPremium ? "text-[#E60000]" : "text-black/30"}`} strokeWidth={1.5} />
            <div className={`text-sm font-medium tracking-tight leading-snug ${isPremium ? "text-black" : "text-black/40"}`}>
              "{p}"
            </div>
            {isPremium ? (
              <ArrowRight className="absolute top-3 right-3 w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" />
            ) : (
              <Lock className="absolute top-3 right-3 w-3.5 h-3.5 text-black/30" />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};
